<template>
    <div class="container">
        <div v-if="settings.type === 2">
            <img :src="image(testimonial.upload, 'thumb')" class="rounded-circle img-center img-fluid shadow shadow-lg--hover" style="width: 180px;">
            <div class="pt-4 text-center">
                <h5 class="h3 title">
                    <span 
                        class="d-block mb-1"
                        :style="{ color: fontColor.title }"
                    >
                        {{translation.title}}
                    </span>
                    <small 
                        class="h4 font-weight-light"
                        :style="{ color: fontColor.description }"
                    >
                        {{translation.description}}
                    </small>
                    <br>
                    <i :style="{color: color.primary}" class="mdi mdi-format-quote-close nch__icon_size"></i>
                    <p 
                        class="text-justify"
                        :style="{ color: fontColor.testimonial }"
                    >
                        {{translation.testimonial}}
                    </p>
                </h5>
            </div>
        </div>
        <div v-else>
            <div class="videoWrapper" v-html="settings.video"></div>
            <div class="pt-4 text-center">
                <h5 class="h3 title">
                    <span 
                        class="d-block mb-1"
                        :style="{ color: fontColor.title }"
                    >
                        {{translation.title}}
                    </span>
                    <small 
                        class="h4 font-weight-light"
                        :style="{ color: fontColor.description }"
                    >
                        {{translation.description}}
                    </small>
                </h5>
            </div>
        </div>

    </div>
</template>

<script>
import image from '../../mixins/image'

export default {
    name: 'HomeTestimonialItem',
    mixins: [image],
    props: {
        testimonial: {
            type: Object,
            required: true
        },
        fontColor: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            translation: this.testimonial.translation,
            settings: this.testimonial.settings
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        }
    }
}
</script>

<style>

.videoWrapper {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 25px;
    height: 0;
}
.videoWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.nch__icon_size {
    font-size: 2rem
}
/* .hooper-slide.is-active {
    margin-top: auto
} */

</style>
